module.exports = __webpack_public_path__ + "img/appointment.0e9fd4b7.svg";